import { NavLink } from "react-router-dom";
import AddEditCustomerModal from "../components/customer-list/customerModal/AddEditCustomerModal";
import ProgressModal from "../components/campaign/ProgressModal";
import CustomButton from "../components/kits/button/CustomButton.jsx";
import TimePicker from "../components/singleProduct/TimePicker";
export default function AllPage() {
  return (
    <div className="m-5 d-flex flex-wrap">
      <div className="m-5 w-100">
        {" "}
        <TimePicker defaultTime={377940} />
      </div>

      <div>
        <NavLink
          className="bg-secondary text-light p-1 m-2 rounded"
          to="/product/6"
        >
          edit productt/fazeli
        </NavLink>
      </div>
      <div>
        <NavLink
          className="bg-secondary text-light p-1 m-2 rounded"
          to="/admin-panel/user-management"
        >
          user management/baset
        </NavLink>
      </div>

      <div className="m-3">
        <AddEditCustomerModal type="add" headerText="ساخت مشتری" />
      </div>
      <div className="m-3">
        <AddEditCustomerModal type="edit" headerText="ویرایش مشتری" data={{}} />
      </div>
      <div className="m-3">
        <NavLink
          to="/customer-list"
          className="bg-secondary text-light p-1 m-2 text-decoration-none"
        >
          customer-list/kiani
        </NavLink>
      </div>
      <div className="m-3">
        {" "}
        <NavLink
          to="/clew-list"
          className="bg-secondary text-light p-1 m-2 text-decoration-none"
        >
          clew-list/kiani
        </NavLink>
      </div>
      <div className="m-3">
        <NavLink
          to="/orders"
          className="bg-secondary text-light p-1 m-4 text-decoration-none"
        >
          order/fazeli
        </NavLink>
      </div>
      <div className="m-3">
        {" "}
        <NavLink
          to="/layout"
          className="bg-danger text-secondary p-1 m-2 text-decoration-none"
        >
          layout / Delshad
        </NavLink>
      </div>
      <div className="m-3">
        {" "}
        <NavLink
          to="/icons"
          className="bg-danger text-light p-1 m-2 text-decoration-none"
        >
          Icon / Delshad
        </NavLink>
      </div>
      <div className="m-3">
        {" "}
        <NavLink
          to="/campain"
          className="bg-danger text-light p-1 m-2 text-decoration-none"
        >
          campainList / Delshad
        </NavLink>
      </div>
      <div className="m-3">
        {" "}
        <NavLink
          to="/messages"
          className="bg-danger text-light p-1 m-2 text-decoration-none"
        >
          message / Delshad
        </NavLink>
      </div>

      <div>
        <NavLink
          to="/storage"
          className="bg-danger text-light p-1 m-2 text-decoration-none"
        >
          storage/ Delshad
        </NavLink>
      </div>
      <NavLink
        to="/customer-list"
        className="bg-secondary text-light p-1 m-2 text-decoration-none"
      >
        customer-list/kiani
      </NavLink>
      <NavLink
        to="/clew-list"
        className="bg-secondary text-light p-1 m-2 text-decoration-none"
      >
        clew-list/kiani
      </NavLink>
      <NavLink
        to="/orders"
        className="bg-secondary text-light p-1 m-4 text-decoration-none"
      >
        order/fazeli
      </NavLink>
      <NavLink
        to="/layout"
        className="bg-danger text-secondary p-1 m-2 text-decoration-none"
      >
        layout / Delshad
      </NavLink>
      <NavLink
        to="/icons"
        className="bg-danger text-light p-1 m-2 text-decoration-none"
      >
        Icon / Delshad
      </NavLink>
      <NavLink
        to="/campain"
        className="bg-danger text-light p-1 m-2 text-decoration-none"
      >
        campainList / Delshad
      </NavLink>
      <NavLink
        to="/messages"
        className="bg-danger text-light p-1 m-2 text-decoration-none"
      >
        message / Delshad
      </NavLink>

      <NavLink
        to="/transactions"
        className="bg-danger text-light p-1 m-2 text-decoration-none"
      >
        transaction list / Delshad
      </NavLink>

      <NavLink
        to="/login"
        className="bg-secondary
        text-light p-1 m-2 text-decoration-none"
      >
        Login / Kia
      </NavLink>
      {/* </div> */}
      <div className="m-3">
        {" "}
        <NavLink
          to="/single-campaign"
          className="bg-secondary text-light p-1 m-2 text-decoration-none"
        >
          Single Campaign / Kia
        </NavLink>
      </div>
      <div>
        <CustomButton type="text" color="blue" size="larger">
          button type text
        </CustomButton>
      </div>
    </div>
  );
}
